import { useConfigStore } from '@/stores/configStore';

/** Returns the building name when the store has multiple buildings and the search menu allows showing it, otherwise ''. */
export const useVisibleBuildingName = (buildingName?: string): string => {
    const hasMultipleBuildings = useConfigStore((s) => (s.config.server?.store?.buildings?.length ?? 0) > 1);
    const showBuildingName = useConfigStore((s) => {
        const config = s.config;
        const searchMenu =
            config.server?.buildingMenus?.[config.ui.language]?.find((menu) => menu.menuType === 'SEARCH') ??
            config.server?.buildingMenus?.[config.ui.mainLanguage]?.find((menu) => menu.menuType === 'SEARCH');
        return searchMenu?.showBuildingName !== false;
    });

    return hasMultipleBuildings && showBuildingName ? (buildingName ?? '') : '';
};
